import styled from "styled-components";

export const TextElement = styled.h1` 
    text-align: center;
`
export const TextHighlight = styled.span`
    color: deepskyblue;
    font-weight: bold;
`

export const ContentContainer = styled.div`
    display: flex;
    margin-top: 15px;
`

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    &:focus {
        border-color: #007bff;
    }
`;

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
`

export const InputContainer = styled.div`
    display: block;
    align-items: center;
    max-width: 400px; 
`

export const ChartContainer = styled.div`
    width: 100%;
    margin: auto;
`